import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common";
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { maternityLeaveSchema } from '../maternityLeaveSchema';
import tokenDecoder from '../../../../components/Common/tokenDecoder';

const screenCode = 'MATERNITYLEAVE';

const useStyles = makeStyles((theme) => ({
    dateField: {
        width: '100%',
    },
    addButton: {
        marginTop: '20px',
        marginBottom: '20px'
    }
}));

export function MaternityLeaveAddEdit(props) {
    const classes = useStyles();
    const { data, edit } = props.location;

    const [title, setTitle] = useState("Add Leave");
    const [groups, setGroups] = useState();
    const [operationEntities, setOperationEntities] = useState();
    const [collectionPoints, setCollectionPoints] = useState();
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [buttonName, setButtonName] = useState("Save");
    const [errors, setErrors] = useState({});
    const [maternityRecords, setMaternityRecords] = useState([]);
    const [isCalculating, setIsCalculating] = useState(false);
    const [currentRecord, setCurrentRecord] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        registrationNumber: '',
        leaveType: 0,
        employeeCode: '',
        fromDate: new Date().toISOString().split('T')[0],
        dayCount: '',
        toDate: new Date().toISOString().split('T')[0],
        isActive: true
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [multipleEstates, setMultipleEstates] = useState([]);
    const schema = Joi.object(maternityLeaveSchema).options({ allowUnknown: true });

    useEffect(() => {
        if (isCalculating) return;

        if (currentRecord.fromDate && currentRecord.dayCount && currentRecord.dayCount > 0) {
            const fromDate = new Date(currentRecord.fromDate);
            const calculatedToDate = new Date(fromDate);
            calculatedToDate.setDate(fromDate.getDate() + parseInt(currentRecord.dayCount) - 1);

            const toDateString = calculatedToDate.toISOString().split('T')[0];

            if (currentRecord.toDate !== toDateString) {
                setIsCalculating(true);
                setCurrentRecord(prev => ({
                    ...prev,
                    toDate: toDateString
                }));
                setTimeout(() => setIsCalculating(false), 0);
            }
        }
    }, [currentRecord.fromDate, currentRecord.dayCount]);

    useEffect(() => {
        if (isCalculating) return;

        if (currentRecord.fromDate && currentRecord.toDate) {
            const from = new Date(currentRecord.fromDate);
            const to = new Date(currentRecord.toDate);
            const diffTime = to - from;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

            if (diffDays > 0 && currentRecord.dayCount !== diffDays) {
                setIsCalculating(true);
                setCurrentRecord(prev => ({
                    ...prev,
                    dayCount: diffDays
                }));
                setTimeout(() => setIsCalculating(false), 0);
            }
        }
    }, [currentRecord.fromDate, currentRecord.toDate]);

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(getOperationEntitiesByGroup());
    }, [currentRecord.groupID]);

    useEffect(() => {
        trackPromise(getCollectionPointsForDropDown());
    }, [currentRecord.operationEntityID]);

    useEffect(() => {
        trackPromise(getLeaveTypesForDropDown());
    }, [currentRecord.operationEntityID]);

    function calculateDayCount(fromDate, toDate) {
        if (!fromDate || !toDate) return '';
        const from = new Date(fromDate);
        const to = new Date(toDate);
        const diffTime = to - from;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        return diffDays > 0 ? diffDays : '';
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode === 'ADDEDITMATERNITYLEAVE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {
            var estateObject = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateObject[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"];
            }
            setMultipleEstates(estateObject);
            setCurrentRecord({
                ...currentRecord,
                groupID: token.groupID
            });
        } else {
            setCurrentRecord({
                ...currentRecord,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID,
            });
        }

        if (data && edit) {
            setTitle("Edit Leave");
            setButtonName("Update");
            const completeDetails = await services.getMaternityLeaveByID(data.maternityLeaveID);
            const calculatedDayCount = calculateDayCount(
                data.fromDate ? data.fromDate.split('T')[0] : '',
                data.toDate ? data.toDate.split('T')[0] : ''
            );
            setCurrentRecord({
                maternityLeaveID: data.maternityLeaveID,
                groupID: completeDetails.groupID || token.groupID,
                operationEntityID: completeDetails.operationEntityID || token.operationEntityID,
                collectionPointID: completeDetails.collectionPointID || 0,
                registrationNumber: data.employeeCode || '',
                leaveType: data.leaveTypeID || 0,
                employeeCode: data.employeeCode || '',
                fromDate: data.fromDate ? data.fromDate.split('T')[0] : '',
                dayCount: calculatedDayCount,
                toDate: data.toDate ? data.toDate.split('T')[0] : ''
            });
        } else {
            setTitle("Add Leave");
            setCurrentRecord({
                ...currentRecord,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups();
        setGroups(result);
    }

    async function getOperationEntitiesByGroup() {
        if (currentRecord.groupID > 0) {
            let filteredData = await services.getOperationalEntityByGroupEntityID(currentRecord.groupID);
            setOperationEntities(filteredData);
        } else {
            setOperationEntities([]);
        }
    }

    async function getCollectionPointsForDropDown() {
        if (currentRecord.operationEntityID > 0) {
            const collectionPoint = await services.getCollectionPointsByOperationentityGroupID(
                currentRecord.operationEntityID,
                currentRecord.groupID
            );
            setCollectionPoints(collectionPoint);
        } else {
            setCollectionPoints([]);
        }
    }

    async function getLeaveTypesForDropDown() {
        if (currentRecord.operationEntityID > 0) {
            const leaveTypeData = await services.getLeaveTypesByOperationEntity(
                currentRecord.operationEntityID
            );
            setLeaveTypes(leaveTypeData);
        } else {
            setLeaveTypes([]);
        }
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.name === 'isActive' ? target.checked : target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, maternityLeaveSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        if (target.name === 'groupID') {
            setCurrentRecord({
                ...currentRecord,
                [e.target.name]: value,
                operationEntityID: 0,
                collectionPointID: 0,
                registrationNumber: '',
                leaveType: 0,
                fromDate: new Date().toISOString().split('T')[0],
                dayCount: '',
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === 'operationEntityID') {
            setCurrentRecord({
                ...currentRecord,
                [e.target.name]: value,
                collectionPointID: 0,
                registrationNumber: '',
                leaveType: 0,
                fromDate: new Date().toISOString().split('T')[0],
                dayCount: '',
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === 'collectionPointID') {
            setCurrentRecord({
                ...currentRecord,
                [e.target.name]: value,
                registrationNumber: '',
                leaveType: 0,
                fromDate: new Date().toISOString().split('T')[0],
                dayCount: '',
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === 'registrationNumber') {
            setCurrentRecord({
                ...currentRecord,
                [e.target.name]: value,
                leaveType: 0,
                fromDate: new Date().toISOString().split('T')[0],
                dayCount: '',
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === 'leaveType') {
            setCurrentRecord({
                ...currentRecord,
                [e.target.name]: value,
                fromDate: new Date().toISOString().split('T')[0],
                dayCount: '',
                toDate: new Date().toISOString().split('T')[0]
            });
        } else {
            setCurrentRecord({
                ...currentRecord,
                [e.target.name]: value
            });
        }

        setErrors(error);
    }

    async function handleRegistrationNumberBlur() {
        const employee = await services.getEmployeeByRegistrationNumber(
            currentRecord.registrationNumber,
            currentRecord.groupID,
            currentRecord.operationEntityID,
            currentRecord.collectionPointID
        );
        if (employee && employee.employeeCode) {
            setCurrentRecord({
                ...currentRecord,
                employeeCode: employee.employeeCode
            });
        } else {
            setCurrentRecord({
                ...currentRecord,
                employeeCode: ''
            });
        }
    }

    async function handleAddToList() {
        const errorMessages = validate(schema, currentRecord);
        if (errorMessages) {
            setErrors(errorMessages);
            return;
        }

        if (!currentRecord.employeeCode) {
            setMessageModel({
                hidden: false,
                type: "Warning",
                disciption: "The registration number does not exist"
            });
            setTimeout(() => {
                setMessageModel({
                    hidden: true
                });
            }, 4000);
            return;
        }

        const duplicateInList = maternityRecords.find(record =>
            record.registrationNumber === currentRecord.registrationNumber &&
            record.leaveType === currentRecord.leaveType &&
            record.fromDate === currentRecord.fromDate &&
            record.toDate === currentRecord.toDate
        );

        if (duplicateInList) {
            setMessageModel({
                hidden: false,
                type: "Warning",
                disciption: "This leave record already exists in the list. Please check the details."
            });
            setTimeout(() => {
                setMessageModel({
                    hidden: true
                });
            }, 4000);
            return;
        }

        const newFromDate = new Date(currentRecord.fromDate);
        const newToDate = new Date(currentRecord.toDate);

        const overlapInList = maternityRecords.find(record => {
            if (record.registrationNumber === currentRecord.registrationNumber &&
                record.leaveType === currentRecord.leaveType) {
                const existingFromDate = new Date(record.fromDate);
                const existingToDate = new Date(record.toDate);
                return (newFromDate <= existingToDate && newToDate >= existingFromDate);
            }
            return false;
        });

        if (overlapInList) {
            setMessageModel({
                hidden: false,
                type: "Warning",
                disciption: `Date overlap: ${overlapInList.fromDate} to ${overlapInList.toDate}. Adjust dates.`
            });
            setTimeout(() => {
                setMessageModel({
                    hidden: true
                });
            }, 5000);
            return;
        }

        try {
            const duplicateCheckModel = {
                groupID: currentRecord.groupID,
                operationEntityID: currentRecord.operationEntityID,
                collectionPointID: currentRecord.collectionPointID,
                registrationNumber: currentRecord.registrationNumber,
                leaveTypeID: currentRecord.leaveType,
                fromDate: currentRecord.fromDate,
                toDate: currentRecord.toDate
            };

            const duplicateCheckResult = await services.checkDuplicateLeave(duplicateCheckModel);

            if (duplicateCheckResult && duplicateCheckResult.employeeLeaveRequestStatusID > 0) {
                const existingFromDate = duplicateCheckResult.existingFromDate
                    ? new Date(duplicateCheckResult.existingFromDate).toLocaleDateString('en-GB')
                    : '';
                const existingToDate = duplicateCheckResult.existingToDate
                    ? new Date(duplicateCheckResult.existingToDate).toLocaleDateString('en-GB')
                    : '';

                setMessageModel({
                    hidden: false,
                    type: "Warning",
                    disciption: `Overlapping leave found in database (${existingFromDate} - ${existingToDate}). Please adjust dates.`
                });

                setTimeout(() => {
                    setMessageModel({
                        hidden: true
                    });
                }, 8000);
                return;
            }
        } catch (error) {
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: "An error occurred while checking for duplicate leave records. Please try again."
            });

            setTimeout(() => {
                setMessageModel({
                    hidden: true
                });
            }, 5000);
            return;
        }

        const newRecord = {
            ...currentRecord,
            tempId: Date.now(),
            leaveTypeName: leaveTypes[currentRecord.leaveType]
        };

        setMaternityRecords([...maternityRecords, newRecord]);
        setCurrentRecord({
            groupID: currentRecord.groupID,
            operationEntityID: currentRecord.operationEntityID,
            collectionPointID: currentRecord.collectionPointID,
            registrationNumber: '',
            leaveType: 0,
            employeeCode: '',
            fromDate: new Date().toISOString().split('T')[0],
            dayCount: '',
            toDate: new Date().toISOString().split('T')[0],
            isActive: true
        });
        setErrors({});
    }

    function handleRemoveFromList(tempId) {
        setMaternityRecords(maternityRecords.filter(record => record.tempId !== tempId));
    }

    async function handleSave(e) {
        e.preventDefault();

        if (edit) {
            const errorMessages = validate(schema, currentRecord);
            if (errorMessages) {
                setErrors(errorMessages);
                return;
            }
            try {
                const duplicateCheckModel = {
                    groupID: currentRecord.groupID,
                    operationEntityID: currentRecord.operationEntityID,
                    registrationNumber: currentRecord.registrationNumber,
                    leaveTypeID: currentRecord.leaveType,
                    fromDate: currentRecord.fromDate,
                    toDate: currentRecord.toDate,
                    maternityLeaveID: currentRecord.maternityLeaveID
                };
                const duplicateCheckResult = await services.CheckDuplicateLeaveForUpdate(duplicateCheckModel);

                if (duplicateCheckResult && duplicateCheckResult.employeeLeaveRequestStatusID > 0) {
                    const existingFromDate = duplicateCheckResult.existingFromDate
                        ? new Date(duplicateCheckResult.existingFromDate).toLocaleDateString('en-GB')
                        : '';
                    const existingToDate = duplicateCheckResult.existingToDate
                        ? new Date(duplicateCheckResult.existingToDate).toLocaleDateString('en-GB')
                        : '';

                    setMessageModel({
                        hidden: false,
                        type: "Warning",
                        disciption: `Overlapping leave found in database (${existingFromDate} - ${existingToDate}). Please adjust dates.`
                    });

                    setTimeout(() => {
                        setMessageModel({
                            hidden: true
                        });
                    }, 8000);
                    return;
                }
            } catch (error) {
                setMessageModel({
                    hidden: false,
                    type: "Error",
                    disciption: "An error occurred while checking for duplicate leave records. Please try again."
                });

                setTimeout(() => {
                    setMessageModel({
                        hidden: true
                    });
                }, 5000);
                return;
            }

            let updateData = {
                ...currentRecord,
                modifiedBy: parseInt(tokenDecoder.getUserIDFromToken())
            };

            const response = await services.updateMaternityLeave(updateData);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: response.statusCode,
                disciption: response.message
            });
            afterSuccessfulyChanged(response.statusCode);
        } else {
            if (maternityRecords.length === 0) {
                setMessageModel({
                    hidden: false,
                    type: "Warning",
                    disciption: "Please add at least one record to save"
                });

                setTimeout(() => {
                    setMessageModel((prevModel) => ({
                        ...prevModel,
                        hidden: true
                    }));
                }, 4000);
                return;
            }

            var token = tokenService.getUserDetailsFromToken();

            let bulkSaveData = maternityRecords.map(record => ({
                groupID: record.groupID,
                operationEntityID: record.operationEntityID,
                collectionPointID: record.collectionPointID,
                registrationNumber: record.registrationNumber,
                leaveType: record.leaveType,
                fromDate: record.fromDate,
                toDate: record.toDate,
                createdBy: parseInt(tokenDecoder.getUserIDFromToken())
            }));
            const response = await services.saveMaternityLeaveBulk(bulkSaveData);

            if (response.statusCode !== "Success") {
                alert(`Failed to save records: ${response.message}`);
                return;
            }

            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Success",
                disciption: "All records saved successfully"
            });
            afterSuccessfulyChanged("Success");
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                props.history.push({ pathname: '/maternityLeave' });
            }, 1500);
        }
    }

    function clearButton() {
        setErrors({});
        if (edit) {
            setCurrentRecord({
                ...currentRecord,
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0]
            });
        } else {
            var token = tokenService.getUserDetailsFromToken();
            setCurrentRecord({
                groupID: token.groupID,
                operationEntityID: token.operationEntityID,
                collectionPointID: 0,
                registrationNumber: '',
                leaveType: 0,
                employeeCode: '',
                fromDate: new Date().toISOString().split('T')[0],
                dayCount: '',
                toDate: new Date().toISOString().split('T')[0],
                isActive: true
            });
            setMaternityRecords([]);
        }
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/maternityLeave"
                        />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={currentRecord.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled || edit}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={currentRecord.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || edit}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.keys(multipleEstates).length === 0 ? operationEntities : multipleEstates
                                            )}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={currentRecord.collectionPointID}
                                            disabled={edit}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="registrationNumber">Registration Number *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="registrationNumber"
                                            name="registrationNumber"
                                            value={currentRecord.registrationNumber}
                                            disabled={edit}
                                            onChange={(e) => handleChange(e)}
                                            onBlur={handleRegistrationNumberBlur}
                                            onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            placeholder="Enter Registration Number"
                                        />
                                        {errors["registrationNumber"] && <FormHelperText className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="leaveType">Leave Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="leaveType"
                                            name="leaveType"
                                            value={currentRecord.leaveType}
                                            disabled={edit}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Leave Type--</MenuItem>
                                            {generateDropDownMenu(leaveTypes)}
                                        </Select>
                                        {errors["leaveType"] && <FormHelperText className="text text-danger">{errors["leaveType"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={currentRecord.fromDate}
                                            //disabled={edit}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            className={classes.dateField}
                                        />
                                        {errors["fromDate"] && <FormHelperText className="text text-danger">{errors["fromDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="dayCount">Number of Days *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="dayCount"
                                            name="dayCount"
                                            type="number"
                                            value={currentRecord.dayCount}
                                            onChange={(e) => handleChange(e)}
                                            onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            inputProps={{
                                                min: 1,
                                                max: 84
                                            }}
                                            placeholder="Enter number of days"
                                        />
                                        {errors["dayCount"] && <FormHelperText className="text text-danger">{errors["dayCount"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={currentRecord.toDate}
                                            //disabled={edit}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            className={classes.dateField}
                                        />
                                        {errors["toDate"] && <FormHelperText className="text text-danger">{errors["toDate"]}</FormHelperText>}
                                    </div>
                                </div>
                                {!edit && (
                                    <div className="form-group row">
                                        <div className="col-md-12 text-right">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleAddToList}
                                                className={classes.addButton}
                                            >
                                                ADD
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {!edit && maternityRecords.length > 0 && (
                                    <div className="form-group row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table className="display dataTable no-footer">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ textAlign: 'center' }}>Registration Number</th>
                                                            <th style={{ textAlign: 'center' }}>Leave Type</th>
                                                            <th style={{ textAlign: 'center' }}>From Date</th>
                                                            <th style={{ textAlign: 'center' }}>To Date</th>
                                                            <th style={{ textAlign: 'center' }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {maternityRecords.map((record) => (
                                                            <tr key={record.tempId}>
                                                                <td style={{ textAlign: 'center' }}>{record.registrationNumber}</td>
                                                                <td style={{ textAlign: 'center' }}>{record.leaveTypeName}</td>
                                                                <td style={{ textAlign: 'center' }}>{record.fromDate}</td>
                                                                <td style={{ textAlign: 'center' }}>{record.toDate}</td>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <button
                                                                        title="Delete"
                                                                        onClick={() => handleRemoveFromList(record.tempId)}
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="card-footer">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value={buttonName}
                                />
                                <input
                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={clearButton}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}